export default {
	timeout: {
		title: "Session about to expire",
		message:
			"You have been inactive for a while. For your security, your session will end shortly.",
		countdown: "Ending in {seconds}s",
		continue: "Stay connected",
		logout: "Log out now",
	},
	expiredByInactivity: "Your session ended due to inactivity.",
};
